import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { FeatureService } from '../../../../services/FeatureService';
import { useConfirm } from '../../../modals/confirm';

moment.locale('es');

export const useBenefitsUpdate = (changeAlert: ChangeAlertCallbackType) => {
    const [loading, setLoading] = useState(false);
    const [getCustomerData, setGetCustomerData] = useState(false);
    const featureService = useRef<FeatureService>();
    const { DialogConfirm, confirm: confirmUpdateStatus } = useConfirm(
        'Remover beneficio',
        '¿Estás seguro que deseas realizar este cambio?'
    )


    const removeFeature = async (data, uuid) => {
        const isConfirm = await confirmUpdateStatus()
        if (isConfirm) {
            setLoading(true);
            let request = {
                feature_uuid: data.uuid,
                customers: [uuid]
            } 
            
            const response = await featureService.current.featureRemove(request);
            if(response.data?.response === 'OK' && response.data?.result['saved']){
                setLoading(false);
                handleGet(true)
                changeAlert(true, 'success', 'El beneficio fue removido con éxito');
            } else {
                setLoading(false);
                changeAlert(true, 'error', response.data.message || 'El beneficio no pudo ser eliminado');
            }
        }
    };

    const addFeature = async (data) => {
        setLoading(true);        
        const response = await featureService.current['featureAssign'](data);
        if(response['data'].response === 'OK' && response['data'].result['saved']){
            setLoading(false);
            handleGet(true);
            changeAlert(true, 'success', 'El beneficio se agregó con éxito');
        } else {
            setLoading(false);
            changeAlert(true, 'error', response['data'].message || 'El beneficio no pudo ser actualizado');
        }
    };

    const handleGet = async (value) => {
        setGetCustomerData(value)
    }

    useEffect(() => {
        featureService.current = new FeatureService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, removeFeature, addFeature, DialogConfirm, getCustomerData, handleGet }
}
